import { ZH, EN } from '@yaotai/common-utils';

const PHONE_LOGIN_LOCALE = {
    [ZH]: {
        errorCodeText: '验证码错误',
        mobilePlaceholder: '请输入手机号',
        verificationCodePlaceholder: '请输入短信验证码',
        getCodeFirstText: '请先获取验证码',
        needAgreeText: '您需要同意相关条款才能使用',
        policyAgree: '我同意',
        neteasePolicy: '《隐私政策》',
        andText: '和',
        userPolicy: '《用户协议》',
        Login: '登录',
    },
    [EN]: {
        errorCodeText: 'Verification code format error',
        mobilePlaceholder: 'Phone number',
        verificationCodePlaceholder: 'Enter SMS verification code',
        getCodeFirstText: 'Please get the verification code first.',
        needAgreeText: 'You need to agree to the terms before you can use it.',
        policyAgree: 'I have read and agree to the',
        neteasePolicy: 'NetEase privacy policy',
        andText: 'and the',
        userPolicy: 'user agreement.',
        Login: 'Log in',
    },
};
const phoneLoginValidateVerificationCode = ({ codePhone, phone, emptyText, notGotCodeText, errorCodeText, fromLogin, lang = ZH, }) => (rule, value) => {
    const codeReg = /^\d{6}$/;
    if (!value && fromLogin)
        return Promise.reject(emptyText ?? PHONE_LOGIN_LOCALE[lang]?.verificationCodePlaceholder);
    else if (phone && codePhone !== phone) {
        return Promise.reject(notGotCodeText ?? PHONE_LOGIN_LOCALE[lang]?.getCodeFirstText);
    }
    else if (value && !codeReg.test(value)) {
        return Promise.reject(errorCodeText ?? PHONE_LOGIN_LOCALE[lang]?.errorCodeText);
    }
    else
        return Promise.resolve();
};

export { PHONE_LOGIN_LOCALE, phoneLoginValidateVerificationCode };
